import React, { useEffect, useState } from 'react';
import FieldError from '../../../shared/fields-errors/field-error';
import { useFormContext } from 'react-hook-form';

function DonorCommentsTemplate(props) {
    const { register, clearErrors, formState: { errors } } = useFormContext();
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        clearErrors();
    }, []); 

    const dynamicColor = props?.settings?.primary_color || `#000000`;

    return (
        <div className='col-lg-12 mt-2 d-flex justify-content-center'>
            <div className={`form-group ${props?.descriptiveAmountView ? 'w-100' : 'w-100'}`}>
               {
                 props?.settings?.is_comment_required && (
                <label className="form-control-label text-bold label-text">
                <span className="text-danger me-1">*</span>
                 {props?.settings?.comments_label}
              </label>
            )
         }
              
                <textarea
                    placeholder={props?.settings?.comments_label}
                    {...register("donor_comments", {
                        validate: {
                            required: (value) => {
                                if (!value && props?.settings?.is_comment_required) return "This field is required";
                                return true
                            }
                        }
                    })}
                    onFocus = {() => setIsFocused(true)}
                    onBlur={() => setIsFocused(false)}
                    style={ isFocused ? {
                         borderColor: dynamicColor,
                        boxShadow: 'none',
                        outline: 'none'
                    } : {}}
                    type="text"
                    className="form-control form-control-rounded" ></textarea>
                {errors?.donor_comments ?
                    <FieldError message={errors?.donor_comments?.message} /> : ''}
            </div>

        </div>
    );
}

export default DonorCommentsTemplate;